import { store } from 'store';
import dayjs from 'dayjs';

/**
 * ערכים דינמיים יחסיים שניתן להשתמש בהם בפילטרים
 */
export type DynamicValue = 
  | 'current_user' // משתמש נוכחי
  | 'today' // היום
  | 'yesterday' // אתמול
  | 'this_week' // השבוע הנוכחי
  | 'last_week' // השבוע שעבר
  | 'this_month' // החודש הנוכחי
  | 'last_month' // החודש שעבר
  | 'last_7_days' // 7 הימים האחרונים
  | 'last_30_days' // 30 הימים האחרונים
  | 'last_90_days'; // 90 הימים האחרונים

/**
 * ממיר ערך דינמי לערך אמיתי
 * @param value הערך הדינמי או ערך רגיל
 * @param fieldType סוג השדה ('dateTime' | 'manager' | 'other')
 * @returns הערך האמיתי
 */
export function resolveDynamicValue(value: any, fieldType?: 'dateTime' | 'manager' | 'other'): any {
  // אם זה לא ערך דינמי, החזר כמו שהוא
  if (typeof value !== 'string' || (!value.startsWith('__dynamic__') && !value.startsWith('_dynamic_'))) {
    return value;
  }

  // חלץ את הערך הדינמי - תמוך בשני פורמטים: __dynamic__ ו-_dynamic_
  const dynamicValue = (value.startsWith('__dynamic__') 
    ? value.replace('__dynamic__', '') 
    : value.replace('_dynamic_', '')) as DynamicValue;

  // טיפול בערכים דינמיים לפי סוג השדה
  if (fieldType === 'manager') {
    if (dynamicValue === 'current_user') {
      const currentUser = store.getState().user;
      return currentUser?.Udid || null;
    }
  }

  if (fieldType === 'dateTime') {
    const now = dayjs();
    
    switch (dynamicValue) {
      case 'today':
        return now.startOf('day').toISOString();
      case 'yesterday':
        return now.subtract(1, 'day').startOf('day').toISOString();
      case 'this_week':
        return now.startOf('week').toISOString();
      case 'last_week':
        return now.subtract(1, 'week').startOf('week').toISOString();
      case 'this_month':
        return now.startOf('month').toISOString();
      case 'last_month':
        return now.subtract(1, 'month').startOf('month').toISOString();
      case 'last_7_days':
        return now.subtract(7, 'day').startOf('day').toISOString();
      case 'last_30_days':
        return now.subtract(30, 'day').startOf('day').toISOString();
      case 'last_90_days':
        return now.subtract(90, 'day').startOf('day').toISOString();
      default:
        return value;
    }
  }

  return value;
}

/**
 * יוצר ערך דינמי מתוך מפתח דינמי
 */
export function createDynamicValue(dynamicValue: DynamicValue): string {
  return `__dynamic__${dynamicValue}`;
}

/**
 * בודק אם ערך הוא ערך דינמי
 */
export function isDynamicValue(value: any): boolean {
  return typeof value === 'string' && value.startsWith('__dynamic__');
}

